import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { css } from 'design'
import { Button } from 'primitives/button'
import { Stack } from 'primitives/containers'

import { spamContactAction } from '../../../reduxes/slices/contacts/actions'
import { makeGetParticipantsForTopic } from '../../../reduxes/slices/participants/selectors'
import { removeParticipant } from '../../../reduxes/slices/topics/actions'
import {
  getSelectedTopic,
  makeGetCurrentParticipantForTopic,
} from '../../../reduxes/slices/topics/selectors'
import { useUnknownContact } from '../use_unknown_contact'
import { UnknownPanel } from './unknown_panel'
import {useAxios} from "../../../hooks/use_axios";

const dialogButtonStyles = css({
  padding: '0 $5',
})

export type UnknownTopicPanelProps = {
  showMessages: boolean
  setShowMessages: React.Dispatch<React.SetStateAction<boolean>>
  toggleAction: any
}

export const UnknownTopicPanel = ({
  showMessages,
  setShowMessages,
  toggleAction,
}: UnknownTopicPanelProps) => {
  const selectedTopic = useSelector<any, any>(getSelectedTopic)

  const { name, handle } = useUnknownContact()

  const dispatch = useDispatch()
  const axios = useAxios()

  const getCurrentParticipantForTopic = useMemo(
    makeGetCurrentParticipantForTopic,
    [],
  )

  const currentParticipant = useSelector((state) =>
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    getCurrentParticipantForTopic(state, { topicId: selectedTopic?.id }),
  )

  const previewMessages = useCallback(() => {
    setShowMessages((prev) => !prev)
  }, [setShowMessages])

  const handleLeave = useCallback(() => {
    dispatch(axios(removeParticipant(selectedTopic?.id, currentParticipant.id)))
  }, [dispatch, axios, selectedTopic?.id, currentParticipant?.id])

  const handleApprove = useCallback(() => {
    dispatch(axios(spamContactAction(handle, 'approve')))
  }, [axios, dispatch, handle])

  const getParticipants = useMemo(makeGetParticipantsForTopic, [])
  const topicParticipants = useSelector((state) =>
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    getParticipants(state, selectedTopic),
  )

  const handleReport = () => {
    toggleAction('report')
  }

  topicParticipants.reduce((result: any, participant: any) => {
    if (
      !participant.team_participant_id &&
      participant.sub_participants_count !== 0
    ) {
      return result
    }
    result.push(participant)
    return result
  }, [])

  return (
    <UnknownPanel
      showMessages={showMessages}
      previewMessages={previewMessages}
      handle={handle}
      name={name}
      subheader={`Added to '${selectedTopic.subject}' by ${handle}`}
    >
      <Stack gap="3" direction="row">
        <Button className={dialogButtonStyles()} onClick={handleLeave}>
          Leave
        </Button>
        <Button className={dialogButtonStyles()} onClick={handleReport}>
          Report
        </Button>
        <Button
          className={dialogButtonStyles()}
          onClick={handleApprove}
          variant={'primary'}
        >
          OK
        </Button>
      </Stack>
    </UnknownPanel>
  )
}
